import React from "react";

const LogoutIcon = () => {
  return (
    <>
      <svg width="14.445" height="14.206" viewBox="0 0 14.445 14.206">
        <g
          id="Group_352"
          data-name="Group 352"
          transform="translate(-1.154 -1.4)"
        >
          <path
            id="Path_2543"
            data-name="Path 2543"
            d="M11,11.077H2m0,0L4.423,9M2,11.077l2.423,2.077"
            transform="translate(0 -2.577)"
            fill="none"
            stroke="#000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.2"
          />
          <path
            id="Path_2544"
            data-name="Path 2544"
            d="M9,5.25c.008-1.414.075-2.179.607-2.679C10.218,2,11.2,2,13.155,2h.692c1.959,0,2.938,0,3.547.571S18,4.062,18,5.9v5.2c0,1.838,0,2.758-.608,3.329-.532.5-1.348.562-2.854.57M9,11.75c.008,1.414.075,2.179.607,2.679a3.131,3.131,0,0,0,2.161.56"
            transform="translate(-3.002)"
            fill="none"
            stroke="#000"
            stroke-linecap="round"
            stroke-width="1.2"
          />
        </g>
      </svg>
    </>
  );
};

export default LogoutIcon;
